module.exports = __webpack_public_path__ + "c1647a4b.png";